import { AnyConstructor } from "Global/Base/types";
import { IItemRenderer } from "../types";
import { HasCaption } from "./hasCaption";
import { HasVisibilityChanged } from "./hasVisibilityChange";

export const rendererMixins = [HasCaption, HasVisibilityChanged];

export const applyRendererMixins = <T extends AnyConstructor<IItemRenderer>>(base: T) =>
    rendererMixins.reduce((currentBase, mixin) => mixin(currentBase), base);
